module.exports = __webpack_public_path__ + "static/img/place.d93b90e6.png";